import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useState } from "react";
import SelectOrganization from "components/SelectOrganization";

type PreviewDataSelectorDialogProps = {
  open: boolean;
  organizationIds?: string[]
  onCancel: () => void;
  handleConfirm: (organizationId: string) => void;
};

const PreviewDataSelectorDialog = ({
  open,
  organizationIds,
  onCancel,
  handleConfirm,
}: PreviewDataSelectorDialogProps) => {
  const { formatMessage: t } = useIntl();
  const [orgId, setOrgId] = useState<string | undefined>(undefined);

  const onOrganizationChange = (id?: string) => {
    setOrgId(id);
  };

  const handleConfirmInner = () => {
    handleConfirm(orgId!);
  };

  return (
    <Dialog open={open} disableEnforceFocus>
      <DialogTitle>
        <T id={"PreviewDataSelectorDialogTitle"} />
      </DialogTitle>
      <DialogContent dividers>
        <SelectOrganization
          organizationIds={organizationIds}
          onChange={onOrganizationChange}
          textFieldProps={{
            required: true,
          }}
          required={true}
          label={t({id: "organization"})}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" data-cy="cancelButton">
          {t({ id: "cancelButton" })}
        </Button>
        <Button
          onClick={handleConfirmInner}
          color="primary"
          data-cy="okButton"
          disabled={orgId == null}
        >
          <T id={"okButton"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDataSelectorDialog;
